<template>
  <div :style="internalStyle">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Viewport',

  props: {
    styles: {
      type: Object,
      default: () => ({ height: '100vvh' })
    }
  },

  data() {
    return {
      forceRecompute: 0
    }
  },

  computed: {
    internalStyle() {
      const recompute = this.forceRecompute // eslint-disable-line
      return this.convertStyle()
    }
  },

  mounted() {
    window.addEventListener('resize', this.updateStyle)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateStyle)
  },

  methods: {
    getWindowHeight() {
      return window.innerHeight
    },
    convertStyle() {
      const windowHeight = this.getWindowHeight()
      const usedStyle = this.styles
      const convertedStyle = {}
      Object.keys(usedStyle).forEach(key => {
        convertedStyle[key] =
          typeof usedStyle[key] === 'string'
            ? this.replaceVvhWithPx(usedStyle[key], windowHeight)
            : usedStyle[key]
      })
      return convertedStyle
    },
    replaceVvhWithPx(propertyStringValue, windowHeight) {
      const vvhRegex = /(\d+(\.\d*)?)vvh(?!\w)/g
      return propertyStringValue.replace(vvhRegex, (_, vvh) => {
        return `${(windowHeight * parseFloat(vvh)) / 100}px`
      })
    },
    updateStyle() {
      this.forceRecompute++
    }
  }
}
</script>
